export const bean = {
  Bean: {
    Adzuki: {
      Cooked: ['Adzuki beans (cooked)'],
      Dry: ['Adzuki beans (dry)'],
    },
    Black: {
      Cooked: ['Black beans (cooked)'],
      Dry: ['Black beans (dry)'],
    },
    'Black-eyed peas': {
      Cooked: ['Black-eyed peas (cooked)'],
      Dry: ['Black-eyed peas (dry)'],
    },
    Cannellini: {
      Cooked: ['Cannellini beans (cooked)'],
      Dry: ['Cannellini beans (dry)'],
    },
    Chickpeas: {
      Cooked: ['Chickpeas (cooked)'],
      Dry: ['Chickpeas (dry)'],
    },
    Fava: {
      Cooked: ['Fava beans (cooked)'],
      Dry: ['Fava beans (dry)'],
    },
    'Great northern': {
      Cooked: ['Great northern beans (cooked)'],
      Dry: ['Great northern beans (dry)'],
    },
    Kidney: {
      Cooked: ['Kidney beans (cooked)'],
      Dry: ['Kidney beans (dry)'],
    },
    Lima: {
      Cooked: ['Lima beans (cooked)'],
      Dry: ['Lima beans (dry)'],
    },
    Mung: {
      Cooked: ['Mung beans (cooked)'],
      Dry: ['Mung beans (dry)'],
    },
    Pinto: {
      Cooked: ['Pinto beans (cooked)'],
      Dry: ['Pinto beans (dry)'],
    },
    Soy: {
      Cooked: ['Soy beans (cooked)'],
      Dry: ['Soy beans (dry)'],
    },
    White: {
      Cooked: ['White beans (dry)'],
      Dry: ['White beans (cooked)'],
    },
  },
}
